<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm"
                 label-width="150px">
            <el-row>
                <el-col :span="24"><el-form-item label="标题" prop="title">
                    <div class="min-input-class">{{dataForm.title}}</div>
                </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24"><el-form-item label="描述" prop="title">
                    <div class="min-input-class">{{dataForm.description}}</div>
                </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="栏目" >
                    <div class="min-input-class">{{dataForm.categoryName}}</div>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="作者" prop="author">
                        <div class="min-input-class">{{dataForm.author}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="发布时间" prop="time">
                    <div class="min-input-class">{{dataForm.time}}</div>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否首页轮播" prop="isIndexScroll">
                        <div class="min-input-class"> <el-tag v-if="dataForm.isIndexScroll==0" type="info">否</el-tag>
                            <el-tag v-else-if="dataForm.isIndexScroll==1"  type="success">是</el-tag></div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24"> <el-form-item label="缩略图" prop="img">
                    <el-image  :src="dataForm.img" alt="" :preview-src-list="[dataForm.img]" style="width: 100px; height: 100px"></el-image>
                </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24"> <el-form-item label="内容" prop="content">
                    <!-- <div v-html="dataForm.content"></div> -->
                    <u-editor v-model="dataForm.content" :config="ueditorConfig"></u-editor>
                </el-form-item>
                </el-col>

            </el-row>

        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>

    </span>
    </el-dialog>
</template>

<script>
    import UEditor from "@/components/ueditor/index";
    export default {
        components: {UEditor},
        data () {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                //表单验证规则
                rules: {
                },
                url: '',
                fileList: [],
                visible: false,
                menuList: [],
                customerList:[],
                dataForm: {
                id: '',
                title: '',
                categoryId: '',
                categoryName: '',
                content: '',
                img: '',
                author: '',
                time: '',
                isIndexScroll: '',
                orderNum: '',
                },
                categorys:[],
                ueditorConfig: {
                    readonly: true
                }
            }
        },
        methods: {
            init (id) {
                if(!id) return
                this.dataForm.id = id
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                        this.$http({
                            url: '/bjba/article/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            console.log(data)
                            this.dataForm.id    = data.data.id
                            this.dataForm.title    = data.data.title
                            this.dataForm.categoryId    = data.data.categoryId
                            this.dataForm.categoryName   = data.data.categoryName
                            this.dataForm.content    = data.data.content
                            this.dataForm.img    = data.data.img
                            this.dataForm.author    = data.data.author
                            this.dataForm.time    = data.data.time
                            this.dataForm.isIndexScroll    = data.data.isIndexScroll
                            this.dataForm.orderNum    = data.data.orderNum
                            this.dataForm.description    = data.data.description
                        })

                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
